var map = {
	"./Home": [
		1082,
		82
	],
	"./Home/": [
		1082,
		82
	],
	"./Home/index": [
		1082,
		82
	],
	"./Home/index.tsx": [
		1082,
		82
	],
	"./Quiz": [
		2112,
		112
	],
	"./Quiz/": [
		2112,
		112
	],
	"./Quiz/index": [
		2112,
		112
	],
	"./Quiz/index.tsx": [
		2112,
		112
	],
	"./Result": [
		5509,
		509
	],
	"./Result/": [
		5509,
		509
	],
	"./Result/index": [
		5509,
		509
	],
	"./Result/index.tsx": [
		5509,
		509
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 629;
module.exports = webpackAsyncContext;